import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, text, align = "left", dark = false }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-turquoise">{eyebrow}</p>
    <h2
      className={`mt-3 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
        dark ? "text-white" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {text && (
      <p className={`mt-4 text-base leading-relaxed ${dark ? "text-white/70" : "text-mutedink"}`}>
        {text}
      </p>
    )}
  </Reveal>
);
